var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "phonebook-contact rounded-20 px-4",
      class: {
        "bg-gray-40": _vm.isStriped,
        "d-flex flex-column ga-4 py-4": _setup.isMobile,
        "phonebook-contact--desktop d-flex align-center ga-5 py-7":
          !_setup.isMobile,
      },
      attrs: { "data-qa": "lpu_phonebook_contact" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "phonebook-contact__name text-body-1 text--text text-break min-w-0",
        },
        [_vm._v("\n    " + _vm._s(_setup.name) + "\n  ")]
      ),
      _vm._v(" "),
      _setup.phoneLabel
        ? _c(
            "div",
            {
              staticClass:
                "phonebook-contact__phone d-flex align-center ga-2 flex-shrink-0",
            },
            [
              _setup.rawHref
                ? _c(
                    "a",
                    {
                      staticClass:
                        "d-flex align-center ga-2 text-subtitle-1 font-weight-medium text--text text-decoration-none",
                      attrs: {
                        "data-qa": "lpu_phonebook_phone",
                        href: _setup.rawHref,
                      },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "ui-icon-phone-call bg-gray-80--text flex-shrink-0",
                        class: _setup.isMobile
                          ? "ui-icon-fz-medium"
                          : "ui-icon-fz-big",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("\n      " + _vm._s(_setup.phoneLabel) + "\n    "),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass:
                        "d-flex align-center ga-2 text-subtitle-1 font-weight-medium text--text",
                      attrs: { "data-qa": "lpu_phonebook_phone" },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "ui-icon-phone-call bg-gray-80--text flex-shrink-0",
                        class: _setup.isMobile
                          ? "ui-icon-fz-medium"
                          : "ui-icon-fz-big",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v("\n      " + _vm._s(_setup.phoneLabel) + "\n    "),
                    ]
                  ),
              _vm._v(" "),
              _setup.adminHref
                ? _c(
                    "a",
                    {
                      staticClass: "adminka flex-shrink-0",
                      attrs: {
                        href: _setup.adminHref,
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_setup.tStatic("Править")) +
                          "\n    "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }